import { Routes, Route } from 'react-router-dom';
import { useAdminAuth } from '../hooks/useAdminAuth';
import { useToast } from '../hooks/useToast';
import AdminLogin from './admin/AdminLogin';
import AdminLayout from './admin/AdminLayout';
import AdminDashboardPage from './admin/AdminDashboardPage';
import AdminTranslationsPage from './admin/AdminTranslationsPage';
import AdminTechnologiesPage from './admin/AdminTechnologiesPage';
import AdminProjectsPage from './admin/AdminProjectsPage';
import AdminProjectEditPage from './admin/AdminProjectEditPage';
import AdminProjectCategoriesPage from './admin/AdminProjectCategoriesPage';
import AdminProjectCategoryEditPage from './admin/AdminProjectCategoryEditPage';
import AdminProjectCarouselPage from './admin/AdminProjectCarouselPage';
import AdminFormationsPage from './admin/AdminFormationsPage';
import AdminExperiencesPage from './admin/AdminExperiencesPage';
import AdminLibraryPage from './admin/AdminLibraryPage';
import AdminAnalyticsPage from './admin/AdminAnalyticsPage';
import Loader from '../components/admin/ui/Loader';

function Admin() {
  const { isAuthenticated, isCheckingSession, isAuthenticating, authError, login, logout } = useAdminAuth();
  const { toast, showToast } = useToast();

  if (isCheckingSession) {
    return (
      <div className="admin">
        <Loader label="Chargement du back office..." />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <AdminLogin onLogin={login} isAuthenticating={isAuthenticating} authError={authError} />;
  }

  return (
    <Routes>
      <Route element={<AdminLayout onLogout={logout} toast={toast} />}>
        <Route index element={<AdminDashboardPage />} />
        <Route path="textes" element={<AdminTranslationsPage showToast={showToast} />} />
        <Route path="technologies" element={<AdminTechnologiesPage showToast={showToast} />} />
        <Route path="projets">
          <Route index element={<AdminProjectsPage showToast={showToast} />} />
          <Route path="categories" element={<AdminProjectCategoriesPage showToast={showToast} />} />
          <Route path="categories/:categoryId" element={<AdminProjectCategoryEditPage showToast={showToast} />} />
          <Route path="carrousel" element={<AdminProjectCarouselPage showToast={showToast} />} />
          <Route path=":seturl" element={<AdminProjectEditPage showToast={showToast} />} />
        </Route>
        <Route path="formations" element={<AdminFormationsPage showToast={showToast} />} />
        <Route path="experiences" element={<AdminExperiencesPage showToast={showToast} />} />
        <Route path="bibliotheque" element={<AdminLibraryPage showToast={showToast} />} />
        <Route path="analytics" element={<AdminAnalyticsPage />} />
      </Route>
    </Routes>
  );
}

export default Admin;
